import {ENDPOINT_TEMPLATES} from 'common/endpoints';
import {commonJwtHeader} from 'common/utils';

const downloadInventoryTemplate = (token, templateDownloadPath) => {
  var headers = commonJwtHeader();
  headers['Content-Type'] = 'application/octet-stream';
  return fetch(`${ENDPOINT_TEMPLATES}${templateDownloadPath}`, {
    method: 'GET',
    headers: headers,
  });
};

const getTemplate = (token, templateParams) => {
  var headers = commonJwtHeader();
  headers['Content-Type'] = 'application/octet-stream';
  templateParams = templateParams.replace('subapplication=', 'subApplication=');
  return fetch(`${ENDPOINT_TEMPLATES}${templateParams}`, {
    method: 'GET',
    headers: headers,
  });
};

export default {
  downloadInventoryTemplate,
  getTemplate,
};
